import { Service, computed, signal } from '@angular/core';
import { maintenances } from './maintenance';

@Service()
export class GlobalBannerService {
  private readonly now = new Date();
  private readonly isDismissed = signal(false);

  readonly activeMaintenance = computed(() => {
    if (this.isDismissed()) return undefined;

    return maintenances.find(
      maintenance =>
        maintenance.startDate.getTime() <= this.now.getTime() &&
        this.now.getTime() <= maintenance.endDate.getTime(),
    );
  });

  dismiss() {
    this.isDismissed.set(true);
  }
}
